import React, { useRef } from 'react';
import _isEmpty from 'lodash/isEmpty';

// Context
import { useCompareContext } from '@/context/compare';

// Controller
import { toggleStickyComparsionMain } from '@/braun/Controllers/CompareTrayController';
import { unlockBodyScroll } from '@/utils/Common/Modal';

// Hooks
import usePushProductCompare from '@/hooks/compare/usePushProductCompare';
import useFetchProductCompareData from '@/hooks/compare/useFetchProductCompareData';
import useDisableNotComparableProducts from '@/hooks/compare/useDisableNotComparableProducts';
import useClearCompare from '@/hooks/compare/useClearCompare';
import useDeselectAllProducts from '@/hooks/compare/useDeselectAllProducts';
import useSetCellHeight from '@/hooks/compare/useSetCellHeight';

// Components
import CompareMenu from '@/braun/components/organisms/CompareMenu';
import CompareTable from '@/braun/components/organisms/CompareTable';

const Compare = () => {
  const compareRef = useRef();
  // Context
  const [{ compareData }] = useCompareContext();
  const compareDataReady = !_isEmpty(compareData);
  const compareOpen =
    compareRef.current &&
    compareRef.current.classList.contains('bra-compareTray--expanded');

  // Hooks
  usePushProductCompare();
  useFetchProductCompareData();
  useDisableNotComparableProducts();
  useClearCompare();
  useDeselectAllProducts();
  useSetCellHeight();

  if (compareOpen && !compareDataReady) unlockBodyScroll();

  return compareDataReady ? (
    <div
      ref={compareRef}
      className='bra-compareTray'
      onScroll={toggleStickyComparsionMain}
    >
      <CompareMenu />
      <CompareTable />
    </div>
  ) : null;
};

export default Compare;
